import React, { CSSProperties, useState } from 'react'
import AgoraUIKit, { layout } from 'agora-react-uikit'
import 'agora-react-uikit/dist/index.css'
import { useParams } from "react-router-dom";

const Home = () => {
    const {stream} = useParams();

    const [videocall, setVideocall] = useState(false)
    const [username, setUsername] = useState(stream)

    return (
        <div style={styles.container}>
            <div style={styles.videoContainer}>
                <h1 style={styles.heading}>DIGITISED - Live Streaming</h1>
                {videocall ? (
                <>
                    <div style={styles.nav}>
                    <p style={{ fontSize: 20}}>
                        Live with {stream}
                    </p>
                    
                    </div>
                    {stream ? (
                        <AgoraUIKit
                            rtcProps={{
                                appId: 'a3fdba5e259f4a17b5c4689f7fba8d86',
                                channel: stream,
                                token: null, // add your token if using app in secured mode
                                role: 'audience',
                                layout: layout.grid,
                                enableScreensharing: false
                            }}
                            rtmProps={{ username: username || 'user', displayUsername: true }}
                            callbacks={{
                                EndCall: () => setVideocall(false)
                            }}
                        />
                    ) :
                        <></>
                    }
                </>
                ) : (
                <div style={styles.content}>
                    <p style={{ fontSize: 25}}>
                        You are about to join {stream}'s live stream
                    </p>
                    
                    <h3 style={styles.btn} onClick={() => setVideocall(true)}>
                    Join Live
                    </h3>
                </div>
                )}
            </div>
        </div>
    )
}

const styles = {
  container: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flex: 1,
    backgroundColor: '#1C2826',
    color: '#ffffff'
  },
  heading: { textAlign: 'center' as const, marginBottom: 0 },
  videoContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  } as CSSProperties,
  nav: { display: 'flex', justifyContent: 'space-around' },
  content: { display: 'flex', 'flex-direction': 'column', 'align-items': 'center', justifyContent: 'center', height: '100%'},

  btn: {
    backgroundColor: '#D64550',
    cursor: 'pointer',
    borderRadius: 5,
    padding: '4px 8px',
    color: '#ffffff',
    fontSize: 20
  },
  input: { display: 'flex', height: 24, alignSelf: 'center' } as CSSProperties
}

export default Home
